export default "__VITE_ASSET__Dw2sdLm5__"